module.exports = __webpack_public_path__ + "img/icon-close-dialog.2a939110.svg";